module.exports = __webpack_public_path__ + "static/img/7.77f4d8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/7.png
// module id = a1o5
// module chunks = 0